import { getProductTranslationKey, productFilters } from 'components/Blotters/Filter/BlotterFilterNext.helpers';
import { DropdownWrapper, SpDropdownItem } from 'components/shared/Dropdown';
import { FC } from 'react';
import { DropdownMenu, DropdownToggle } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import type { ProductFilter } from 'state/blotters/common/blotter.model';

interface ProductFilterProps {
  value: ProductFilter;
  filterPredicate?: (product: ProductFilter) => boolean;
  onSelect: (value: ProductFilter) => void;
}

export const ProductFilterComponent: FC<ProductFilterProps> = ({ value, filterPredicate = () => true, onSelect }) => {
  return (
    <DropdownWrapper className="btn-group border-start border-opacity-40" openOnHover>
      <DropdownToggle
        aria-haspopup="listbox"
        variant="link"
        data-e2e="product-filter"
        className="btn btn-flat-secondary btn-lg btn-icon-start dropdown-toggle pe-2"
      >
        <i className="icon">category</i>
        <span className="d-none d-xl-inline">
          <FormattedMessage id={getProductTranslationKey(value)} />
        </span>
      </DropdownToggle>
      <DropdownMenu role="listbox">
        {productFilters.filter(filterPredicate).map(product => (
          <SpDropdownItem active={product === value} key={product} onClick={() => onSelect(product)}>
            <FormattedMessage id={getProductTranslationKey(product)} />
          </SpDropdownItem>
        ))}
      </DropdownMenu>
    </DropdownWrapper>
  );
};
